import { typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable unicorn/filename-case */

/* eslint-disable eqeqeq */

/**
 * Taken directly from the lodash v4.17.4 node package.
 * src files copied here to avoid relying on the whole dependency.
 * Source Here: https://github.com/lodash/lodash/blob/master/isObject.js
 *
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * isObject({})
 * // => true
 *
 * isObject([1, 2, 3])
 * // => true
 *
 * isObject(Function)
 * // => true
 *
 * isObject(null)
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);

  return value != null && (type == 'object' || type == 'function');
}
/*eslint-enable */

export default isObject;
